/* @flow */

import type { JSON, JSONObject } from 'common/types';

type Map<K, V> = { [key: K]: V };

export default function map<K, V>(
  extractKey: JSON => K,
  extractValue: JSON => V
): JSONObject => Map<K, V> {
  return json =>
    Object.keys((json: Object)).reduce((m: Map<K, V>, key): Map<K, V> => {
      m[extractKey(key)] = extractValue(json[key]);
      return m;
    }, {});
}
